var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 6.5c0-.276.236-.5.526-.5h18.948c.29 0 .526.224.526.5s-.236.5-.526.5H2.526A.514.514 0 0 1 2 6.5M2 12c0-.276.236-.5.526-.5H14.99c.29 0 .526.224.526.5s-.236.5-.527.5H2.527A.514.514 0 0 1 2 12m0 5.5c0-.276.236-.5.526-.5h6.148c.29 0 .526.224.526.5s-.236.5-.526.5H2.526A.514.514 0 0 1 2 17.5",
    clipRule: "evenodd"
  })));
};
export default SvgSort;